import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53f1b1aa")

_pushScopeId("data-v-53f1b1aa")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-cancel" })
], -1)
const _hoisted_2 = { class: "dialog__content" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: "/images/home/logo_main.png"
}, null, -1)
const _hoisted_4 = { class: "dialog__list" }
const _hoisted_5 = { class: "dialog__item" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-user-o" }, null, -1)
const _hoisted_7 = { class: "dialog__item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-lock" }, null, -1)
const _hoisted_9 = { class: "dialog__notes" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Mot de passe oublié ")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "icon-help" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Vous n'avez pas de compte? ")
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "icon-user-add" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-attention" }, null, -1)
const _hoisted_16 = { class: "footer__buttons" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "icon-login" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Se connecter ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.loginDialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: false,
            tabindex: "0",
            onClose: _ctx.closeDialog,
            onKeyup: _withKeys(_ctx.requestLogin, ["enter"]),
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"])
          }, {
            body: _withId(() => [
              _createVNode("div", {
                class: "button button--minimal close__button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
              }, [
                _hoisted_1
              ]),
              _createVNode("div", _hoisted_2, [
                _hoisted_3,
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      placeholder: "Courriel",
                      tabindex: "0",
                      ref: "username",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginUsername = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.loginUsername]
                    ])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _withDirectives(_createVNode("input", {
                      type: "password",
                      ref: "password",
                      tabindex: "0",
                      placeholder: "Mot de passe",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", {
                    class: "notes notes--lighter",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
                  }, [
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _createVNode("div", {
                    class: "notes notes--lighter",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showSignupDialog && _ctx.showSignupDialog(...args)))
                  }, [
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _createVNode("div", {
                    class: "notes notes--info",
                    style: {
                                'visibility': _ctx.forgotPassMsg !== ''? 'visible': 'hidden'
                            }
                  }, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.forgotPassMsg), 1)
                  ], 4),
                  _createVNode("div", {
                    class: "notes notes--error",
                    style: {
                                'visibility': _ctx.loginError? 'visible': 'hidden'
                            }
                  }, [
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.loginErrorMsg), 1)
                  ], 4)
                ])
              ])
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_16, [
                _createVNode("div", {
                  class: "button button--action button--grow",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.requestLogin && _ctx.requestLogin(...args)))
                }, [
                  _createVNode("span", null, [
                    _hoisted_17,
                    _hoisted_18,
                    _createVNode("i", {
                      class: {
                                    'icon-right-open': _ctx.loginReady,
                                    'icon-spinner animate-spin': _ctx.loginLoading
                                }
                    }, null, 2)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeyup", "onKeydown"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})